/* ============================================================================
 * mb-devis.js — Bloc devis des fiches brodeuses (section main-product-mb, trop
 * grosse pour être réécrite par l'API : on agit donc en JS).
 *
 * 1) #mb-devis-form : on remplace le formulaire de contact natif par le
 *    formulaire Tally « Demander un devis » (mK0AdD), en iframe. Mise en page :
 *    intro à gauche, formulaire à droite (700px = largeur Tally), empilé mobile.
 *    Hauteur AUTO (dynamicHeight via embed.js) : l'iframe épouse la hauteur de
 *    chaque étape du formulaire -> plus d'espace blanc géant sous les étapes
 *    courtes. Repli hauteur mini si le resize Tally n'aboutit pas.
 * 2) Boutons « Demander un devis » ([data-devis-open] + .pv-btn-ghost de la
 *    carte d'achat) : ouvrent le formulaire Tally COURT (VLyL5N) en pop-up.
 *    Le script Tally est préchargé et on attend qu'il soit prêt avant d'ouvrir
 *    -> plus d'ouverture en nouvel onglet.
 * 3) Menu mobile : on injecte un bouton « Demander un devis » mis en avant en
 *    HAUT du drawer (.mbh-drawer__body), avant bindDevisButtons() pour qu'il
 *    soit câblé comme les autres (pop-up Tally courte).
 * ========================================================================== */
(function () {
  'use strict';

  var TALLY_JS = 'https://tally.so/widgets/embed.js';

  /* Charge embed.js puis exécute cb() une fois Tally disponible. */
  function ensureTallyScript(cb) {
    if (typeof Tally !== 'undefined') { if (cb) cb(); return; }
    var existing = document.querySelector('script[src="' + TALLY_JS + '"]');
    if (existing) {
      if (cb) existing.addEventListener('load', cb);
      return;
    }
    var sc = document.createElement('script');
    sc.src = TALLY_JS;
    if (cb) sc.addEventListener('load', cb);
    document.body.appendChild(sc);
  }

  var styled = false;
  function injectStyle() {
    if (styled) return;
    styled = true;
    var css = ''
      + '.pp-quote-wrap{grid-template-columns:minmax(0,1fr) minmax(0,700px) !important;gap:48px !important;align-items:start !important;}'
      + '@media(max-width:1000px){.pp-quote-wrap{grid-template-columns:1fr !important;gap:28px !important;max-width:760px !important;margin-left:auto !important;margin-right:auto !important;}}'
      + '.pp-quote-intro p{max-width:none !important;}'
      + '.pp-quote-form.mbq-form{display:block !important;max-width:none !important;background:transparent !important;border:0 !important;padding:0 !important;}'
      + '.mbq-title{font-family:var(--mb-font-display,"LEMON MILK",sans-serif);text-transform:uppercase;letter-spacing:.02em;color:var(--mb-navy,#1c2646);text-align:center;margin:0;font-size:clamp(20px,2.4vw,28px);}'
      + '.mbq-tally{width:100%;border:0;min-height:320px;display:block;margin-top:-18px;transition:height .2s ease;}';
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  }

  function buildDevisForm() {
    var form = document.getElementById('mb-devis-form');
    if (!form) return;
    form.classList.add('mbq-form');
    injectStyle();

    form.innerHTML = '<h2 class="mbq-title">Demande de devis</h2>'
      + '<iframe class="mbq-tally" src="https://tally.so/embed/mK0AdD?transparentBackground=1&hideTitle=1&dynamicHeight=1" loading="lazy" width="100%" height="480" frameborder="0" marginheight="0" marginwidth="0" title="Demander un devis"></iframe>';

    /* Le formulaire Tally est multi-étapes : chaque étape a une hauteur très
     * différente (~480px pour le choix du modèle, ~810px pour la livraison...).
     * Tally.loadEmbeds() ne parvient pas à initialiser le redimensionnement auto
     * dans ce thème (d'où l'ancienne hauteur figée à 700px = gros vide sous les
     * étapes courtes). On applique donc la hauteur nous-mêmes : le child
     * iframe-resizer poste la hauteur réelle du contenu à chaque changement via
     * des messages "[iFrameSizer]<id>:<hauteur>:<largeur>:<type>:...".
     * Filtré sur e.source pour ne réagir qu'à NOTRE iframe (pas au pop-up). */
    var ifr = form.querySelector('iframe.mbq-tally');
    window.addEventListener('message', function (e) {
      if (!ifr || e.source !== ifr.contentWindow) return;
      if (String(e.origin).indexOf('tally.so') === -1) return;
      var d = e.data;
      if (typeof d !== 'string' || d.indexOf('[iFrameSizer]') !== 0) return;
      var h = parseInt(d.replace('[iFrameSizer]', '').split(':')[1], 10);
      if (!isNaN(h) && h > 100) { ifr.style.height = h + 'px'; }
    });
  }

  /* Menu mobile : bouton devis mis en avant, tout en haut du drawer. */
  function injectMobileDevis() {
    var body = document.querySelector('.mbh-drawer__body');
    if (!body || body.querySelector('.mbh-drawer__devis-top')) return;
    var a = document.createElement('a');
    a.className = 'mbh-drawer__devis-top';
    a.href = '/pages/devis';
    a.setAttribute('data-devis-open', '');
    a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg> Demander un devis';
    body.insertBefore(a, body.firstChild);
  }

  function bindDevisButtons() {
    var SHORT = 'VLyL5N';        // formulaire devis court (générique)
    var REPRISE = 'GxjjQZ';      // formulaire « Offre de reprise » (logiciel déjà possédé)
    /* Sélecteur unique -> pas de doublon si un élément coche plusieurs critères. */
    var triggers = [].slice.call(document.querySelectorAll('[data-devis-open], .pv-buycard-actions .pv-btn-ghost, a.is-reprise'));
    if (!triggers.length) return;
    ensureTallyScript();

    function openForm(formId, e) {
      if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
      ensureTallyScript();
      /* On garde le titre du formulaire de reprise (« Changement de logiciel ! »)
         pour une présentation propre ; le devis court générique reste sans titre. */
      var keepTitle = (formId === REPRISE);
      var tries = 0;
      (function waitReady() {
        if (typeof Tally !== 'undefined' && Tally.openPopup) {
          Tally.openPopup(formId, { layout: 'modal', width: 720, overlay: true, hideTitle: !keepTitle });
          return;
        }
        if (tries++ > 50) {
          window.open('https://tally.so/r/' + formId, '_blank', 'noopener');
          return;
        }
        setTimeout(waitReady, 100);
      })();
    }

    triggers.forEach(function (oldBtn) {
      /* Le lien « Offre de reprise » du menu logiciels ouvre le formulaire reprise ;
         tous les autres boutons ouvrent le devis court générique. */
      var formId = (oldBtn.classList && oldBtn.classList.contains('is-reprise')) ? REPRISE : SHORT;
      var b = oldBtn.cloneNode(true);
      b.removeAttribute('data-devis-open');
      b.removeAttribute('data-tally-open');
      if (b.tagName === 'A') b.setAttribute('href', 'javascript:void(0)');
      b.style.cursor = 'pointer';
      b.addEventListener('click', function (e) { openForm(formId, e); }, true);
      oldBtn.parentNode.replaceChild(b, oldBtn);
    });
  }

  function init() { injectMobileDevis(); buildDevisForm(); bindDevisButtons(); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
